import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const LoadingBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 30px auto 0;
  max-width: 1260px;
  width: 100%;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const SlideButton = styled.button<{ hidden?: boolean; disabled?: boolean }>`
  background: ${(props) => props.theme.primary};
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;

  ${(props) =>
    props.hidden &&
    `
    display: none;
  `}

  ${(props) =>
    props.disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const Container = styled.div`
  position: relative;
  margin: 10px auto 0;
  display: flex;
  flex-direction: row;
  max-width: 1200px;
  width: 100%;
  overflow: hidden;

  .swiper-slide {
    transform: none !important;
  }
`;

export const SchoolNames = styled.div`
  position: relative;
  max-width: 220px;
  min-width: 220px;
  display: flex;
  flex-direction: column;
  z-index: 5;

  @media (${mobileXXLargeMax}) {
    max-width: 140px;
    min-width: 140px;
  }
`;

export const SchoolName = styled.div`
  background: ${(props) => props.theme.backgroundMid};
  height: 70px;
  border-bottom: 1px solid ${(props) => props.theme.white};
  border-right: 1px solid ${(props) => props.theme.backgroundLight};
  display: flex;
  align-items: center;
  padding: 0 15px;

  p {
    font-size: 14px;
    font-weight: 600;
    color: ${(props) => props.theme.background};
  }

  &:first-child {
    background: ${(props) => props.theme.backgroundDark};
  }

  &:last-child {
    border-bottom: 1px solid ${(props) => props.theme.backgroundLight};
  }

  @media (${mobileXXLargeMax}) {
    p {
      font-size: 12px;
    }
  }
`;

export const Rail = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Cell = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 70px;
  max-height: 70px;
  padding: 0 10px;
  border-bottom: 1px solid ${(props) => props.theme.backgroundLight};
  border-right: 1px solid ${(props) => props.theme.backgroundLight};

  p {
    font-size: 14px;
    text-align: center;
    color: ${(props) => props.theme.textDark};
  }

  @media (${mobileXXLargeMax}) {
    p {
      font-size: 12px;
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;

  ${Cell}:nth-child(1n+1) {
    background: ${(props) => props.theme.backgroundLightest};
  }

  ${Cell}:nth-child(2n+1) {
    background: ${(props) => props.theme.backgroundLighter};
  }

  ${Cell}:first-child {
    background: ${(props) => props.theme.backgroundDark};

    p {
      font-weight: 600;
      color: ${(props) => props.theme.background};
    }
  }
`;

export const InfoBox = styled.div`
  position: relative;
`;
